function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#ACACAC",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-1 763.826 -100.589) translate(1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.337,
  cy: 7.423,
  rx: 6.504,
  ry: 6.423
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 25.012,
  cy: 7.423,
  rx: 6.504,
  ry: 6.423
})), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M2.5 8L0 8M36 8L33 8",
  transform: "rotate(-1 763.826 -100.589)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 5c1.667-2.667 3.333-2.667 5 0",
  transform: "rotate(-1 763.826 -100.589)"
}));

var SvgGlasses = function SvgGlasses(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlasses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glasses.3bcacb5e.svg";
export { ForwardRef as ReactComponent };